import { createBreadCrumb, createBreadCrumbForClearance } from "helpers/category-helpers";
import { useSelector } from "react-redux";
import { isSSR } from "helpers/client-server-helper";
import styles from "./pdp-breadcrumbs.module.scss";
import PropTypes from "prop-types";
import { buildSeoBreadcrumbSchema } from "helpers/seo-helpers/breadcrumbs-schema-helper.js";

const PDPBreadCrumbs = ({ productDrawer }) => {
  // do not display this if is a product drawer
  if (productDrawer) return;

  const staticProduct = useSelector(state => state.staticProduct);
  const isBuyNow = useSelector(state => state.isBuyNow);
  const initialUrl = useSelector(state => state.initialUrl);

  // adding "/" to the check to avoid tests failing
  const origin = (initialUrl && initialUrl !== "" && initialUrl !== "/" && new URL(initialUrl)?.origin) ?? "";
  const breadCrumbs = buildBreadCrumbs(staticProduct, isBuyNow);

  buildSeoBreadcrumbSchema(breadCrumbs, origin);
  return (
    <div className={`${styles["breadcrumbs-inline"]}`} data-test-id="breadcrumbs">
      {breadCrumbs.map((o, index) => {
        return (
          <a key={`breadcrumb-${index}`} href={origin + o.url}>
            {o.category + `${breadCrumbs.length - 1 === index ? "" : " / "}`}
          </a>
        );
      })}
    </div>
  );
};

PDPBreadCrumbs.propTypes = {
  productDrawer: PropTypes.bool,
};

export default PDPBreadCrumbs;

export const buildBreadCrumbs = (staticProduct, isBuyNow) => {
  let mode = "";
  const breadCrumbsArray = [];
  const { categoryTree = [], category = "", merchandisingCategory = "" } = staticProduct || {};

  if (!Array.isArray(categoryTree) || categoryTree.length <= 0 || !category) return breadCrumbsArray;

  if (isBuyNow) {
    mode = "BUYNOW";
  } else if (merchandisingCategory === "Clearance") {
    mode = "CLEARANCE";
  }

  // if clearance use clearance fn and for normal/buynow grids get their respecitve url
  const getBreadCrumbForGridType =
    merchandisingCategory === "Clearance"
      ? createBreadCrumbForClearance().extractClearanceBreadCrumbFromCategory
      : createBreadCrumb().extractBreadCrumbFromCategory;

  // add the parent of all categories to breadcrumb
  breadCrumbsArray.push(getBreadCrumbForGridType("ALL", mode));

  for (const eachCategory of categoryTree) {
    const breadCrumb = getBreadCrumbForGridType(eachCategory, mode);

    if (breadCrumb) {
      breadCrumbsArray.push(breadCrumb);
    } else if (isSSR()) {
      // purposefully leaving the log here to get log info from splunk

      console.log(
        "PDPBreadCrumbs breadCrumbs",
        staticProduct?.productId,
        "isBuyNow",
        isBuyNow,
        "merchandisingCategory",
        merchandisingCategory,
        "category",
        category
      );
    }

    if (category === eachCategory) return breadCrumbsArray;
  }
  return breadCrumbsArray;
};
